/* @ngInject */
function FloatingToolBarController ($rootScope, $state, $scope, $timeout, $q, $translate, UdsModalService, Utils, RepositoryService, NewAssetService, ToastService, AssetService, SegmentService) {
  const getMoveToTrashDialogController = () => $q.when(import('../../dialogs/move-to-trash/move-to-trash-dialog.controller'))
  const getOrganizeAssetDialogController = () => $q.when(import('../../dialogs/organize-asset/organize-asset-dialog.controller'))
  const getManageAssetsDialogController = () => $q.when(import('../../dialogs/manage-assets/manage-assets-dialog.controller'))
  const getShareWithGuestsDialogController = () =>
    $q.when(import('../../../core/dialogs/share-with-guests/share-with-guests-dialog.controller'))

  const api = {
    getShareWithGuestsDialogController,
    getMoveToTrashDialogController,
    getOrganizeAssetDialogController,
    getManageAssetsDialogController,
    _removeAssetsFromList,
    _successCopyLinks,
    _errorCopyLinks,
    _downloadAssets,
    _downloadFolders,
    _normalizeData,
    _checkShowShareButton
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._checkShowShareButton()
  }

  function _checkShowShareButton () {
    Promise.all([
      $rootScope.getCompanyFeaturesAndAddons(),
      $rootScope.getCompanyFeatures(),
      $rootScope.getUser()
    ]).then(([{ features }, companyFeatures, user]) => {
      $scope.showShareButton = (features['SHARE.GUEST'] || companyFeatures.includes('GUEST_ASSET_PACK')) && $rootScope.isUserSysAdminAdmin(user)
    })
  }

  $scope.shouldShowLinkOrDownloadButton = () => {
    if ($scope.selectedAssets.some(asset => asset.extension === 'deskfy')) {
      return false
    }

    return true
  }

  $scope.unselectAllAssets = () => {
    $scope.selectedAssets = []
    $scope.selectedFolders = []
  }

  const deregisterUnselectAllAssetsAndFolders = $rootScope.$on('folders-assets.deselect', () => {
    $scope.unselectAllAssets()
  })

  $scope.$on('$destroy', () => {
    deregisterUnselectAllAssetsAndFolders()
  })

  $scope.restoreSelectedAssets = (selectedAssets) => {
    const nameDisplayLength = 32
    const assets = selectedAssets.map(selectedAsset => {
      return {
        id: selectedAsset.id,
        assetName: RepositoryService.defineFullAssetNameToDisplay(selectedAsset, nameDisplayLength)
      }
    })

    api.getOrganizeAssetDialogController().then(({ OrganizeAssetController }) => {
      const organizeAssetDialog = UdsModalService.createModal({
        controller: OrganizeAssetController,
        modalName: 'organizeAssetDialog',
        data: {
          assets,
          isRestoring: true,
          hasOrganizedFeature: $scope.pricing.organized.access
        },
        onClose: ({ hasMoved }) => {
          if (hasMoved) {
            $timeout(() => {
              api._removeAssetsFromList(selectedAssets, $scope.sections)
            })
          }
        }
      })

      organizeAssetDialog.open()
    })
  }

  $scope.restoreSelectedFolders = (selectedFolders) => {
    const nameDisplayLength = 32
    const folders = selectedFolders.map(selectedFolder => {
      return {
        id: selectedFolder.id,
        assetName: Utils.truncateText(selectedFolder.title, nameDisplayLength),
        isFolder: true
      }
    })

    api.getOrganizeAssetDialogController().then(({ OrganizeAssetController }) => {
      const organizeAssetDialog = UdsModalService.createModal({
        controller: OrganizeAssetController,
        modalName: 'organizeAssetDialog',
        data: {
          assets: folders,
          isRestoring: true,
          hasOrganizedFeature: $scope.pricing.organized.access
        },
        onClose: ({ hasMoved }) => {
          if (hasMoved) {
            api._removeAssetsFromList(selectedFolders, $scope.sections)
          }
        }
      })

      organizeAssetDialog.open()
    })
  }

  $scope.archiveSelectedAssets = (selectedAssets) => {
    const nameDisplayLength = 32
    const assets = selectedAssets.map(selectedAsset => {
      return {
        id: selectedAsset.id,
        assetSize: selectedAsset.assetSize ? selectedAsset.assetSize : Utils.getReadableFileSizeString(selectedAsset.size),
        assetName: selectedAsset.assetName ? selectedAsset.assetName : RepositoryService.defineFullAssetNameToDisplay(selectedAsset, nameDisplayLength),
        assetIcon: selectedAsset.assetIcon ? selectedAsset.assetIcon : RepositoryService.defineAssetIconBasedOnExtension(selectedAsset)
      }
    })

    api.getMoveToTrashDialogController().then(({ MoveToTrashController }) => {
      const moveToTrashDialog = UdsModalService.createModal({
        controller: MoveToTrashController,
        modalName: 'moveToTrashDialog',
        data: {
          assets,
          selectedAssets: $scope.selectedAssets
        },
        onClose: hasMoved => {
          if (hasMoved) {
            api._removeAssetsFromList(selectedAssets, $scope.sections)
          }
        }
      })

      moveToTrashDialog.open()
    })
  }

  $scope.archiveSelectedFolders = (selectedFolders) => {
    const nameDisplayLength = 32
    const folders = selectedFolders.map(selectedFolder => {
      return {
        id: selectedFolder.id,
        // assetSize: '10MB',
        assetName: selectedFolder.assetName ? selectedFolder.assetName : Utils.truncateText(selectedFolder.title, nameDisplayLength),
        assetIcon: 'dam',
        isFolder: true
      }
    })

    api.getMoveToTrashDialogController().then(({ MoveToTrashController }) => {
      const moveToTrashDialog = UdsModalService.createModal({
        controller: MoveToTrashController,
        modalName: 'moveToTrashDialog',
        data: {
          assets: folders,
          selectedAssets: $scope.selectedFolders
        },
        onClose: hasMoved => {
          if (hasMoved) {
            api._removeAssetsFromList(selectedFolders, $scope.sections)
          }
        }
      })

      moveToTrashDialog.open()
    })
  }

  function _removeAssetsFromList (selectedAssets, sections) {
    $timeout(() => {
      selectedAssets.forEach((selectedAsset) => {
        let assetIndex = null

        sections.forEach((section) => {
          assetIndex = section.assets.findIndex(asset => asset.id === selectedAsset.id)

          if (assetIndex >= 0) {
            section.assets.splice(assetIndex, 1)
            section.totalCount--
          }
        })
      })

      $scope.selectedAssets = []
      $scope.selectedFolders = []
    })
  }

  $scope.copyAssetsLinks = (selectedAssets, selectedFolders) => {
    if (selectedAssets.length) {
      return NewAssetService.copyAssetsUrlsToClipboard(selectedAssets)
        .then(api._successCopyLinks)
        .catch(api._errorCopyLinks)
    }

    RepositoryService.copyAssetsFolderUrlsToClipboard(selectedFolders)
      .then(api._successCopyLinks)
      .catch(api._errorCopyLinks)
  }

  function _normalizeData (selectedAssets, selectedFolders) {
    const assets = selectedAssets.map(asset => ({
      id: asset.id,
      type: 'asset'
    }))

    const folders = selectedFolders.map(folder => ({
      id: folder.id,
      type: 'folder'
    }))

    const assetPack = assets.concat(folders)
    const packTitle = selectedAssets.length > 0 ? selectedAssets[0].name : selectedFolders[0].title

    return {
      itemType: 'assetPack',
      assetPack,
      packTitle
    }
  }

  $scope.openShareDialog = (selectedAssets, selectedFolders) => {
    api.getShareWithGuestsDialogController().then(({ ShareWithGuestsDialogController }) => {
      const shareWithGuestsDialog = UdsModalService.createModal({
        controller: ShareWithGuestsDialogController,
        modalName: 'shareWithGuestsDialog',
        data: api._normalizeData(selectedAssets, selectedFolders)
      })
      shareWithGuestsDialog.open()
    })
  }

  function _successCopyLinks () {
    const nameDisplayLength = 32
    const selectedMaterials = $scope.selectedFolders.length ? $scope.selectedFolders : $scope.selectedAssets
    const isFolder = !!$scope.selectedFolders.length
    const itemName = $scope.selectedFolders.length
      ? $scope.selectedFolders[0].title
      : RepositoryService.defineFullAssetNameToDisplay($scope.selectedAssets[0], nameDisplayLength)

    const toasts = {
      singleItem: isFolder ? 'assetFolder.toasts.copyLink.success' : 'repository.toasts.copyLink.success',
      batch: isFolder ? 'assetFolder.toasts.copyLinkBatch.success' : 'repository.toasts.copyLinkBatch.success'
    }

    ToastService.showSuccessToast($translate.instant(
      selectedMaterials.length > 1
        ? toasts.batch
        : toasts.singleItem, { itemName }
    ))
  }

  function _errorCopyLinks () {
    const selectedMaterials = $scope.selectedFolders.length ? $scope.selectedFolders : $scope.selectedAssets
    const isFolder = !!$scope.selectedFolders.length

    const toasts = {
      singleItem: isFolder ? 'assetFolder.toasts.copyLink.error' : 'repository.toasts.copyLink.error',
      batch: isFolder ? 'assetFolder.toasts.copyLinkBatch.error' : 'repository.toasts.copyLinkBatch.error'
    }

    ToastService.showErrorToast($translate.instant(
      selectedMaterials.length > 1
        ? toasts.batch
        : toasts.singleItem
    ))
  }

  $scope.downloadSelectedAssetsOrFolders = (selectedAssets, selectedFolders) => {
    if (selectedAssets.length) {
      return api._downloadAssets(selectedAssets)
    }

    if (selectedFolders.length) {
      return api._downloadFolders(selectedFolders)
    }
  }

  function _downloadAssets (assets) {
    const isMultipleAssets = assets.length > 1
    const trackDownload = () => {
      assets.forEach(asset => {
        SegmentService.track('downloaded-file', { asset_id: asset.id })
      })
    }

    if (isMultipleAssets) {
      return NewAssetService.downloadAssetsBatch(assets, 'REPOSITORY').then(trackDownload)
    }

    AssetService.downloadAsset(assets[0].id).then(trackDownload)
  }

  function _downloadFolders (folders) {
    const folderIds = folders.map(folder => folder.id)
    RepositoryService.downloadAssetsFolderBatch(folderIds, 'REPOSITORY')
      .then(() => {
        ToastService.showSuccessToast($translate.instant('assetFolder.toasts.downloadAssets.success'))
        folders.forEach(folder => {
          SegmentService.track('downloaded-file', { folder_id: folder.id })
        })
      })
      .catch(() => {
        ToastService.showErrorToast($translate.instant('assetFolder.toasts.downloadAssets.error'))
      })
  }

  $scope.openSettingsBatch = (selectedAssets, selectedFolders, tabToOpen) => {
    getManageAssetsDialogController().then(({ ManageAssetsDialogController }) => {
      const manageAssetsDialog = UdsModalService.createModal({
        controller: ManageAssetsDialogController,
        modalName: 'manageAssetsDialog',
        data: {
          assets: selectedAssets,
          folders: selectedFolders,
          tabToOpen
        },
        onClose: (updatedItem) => {
          if (!updatedItem) return

          if (updatedItem.isFolder) {
            const folderNameWasUpdated = updatedItem.name !== selectedFolders[0].title

            if (folderNameWasUpdated) {
              $rootScope.$emit('asset-folder.update-folder-name', updatedItem.id, updatedItem.name)
            }

            return
          }

          const assetNameWasUpdated = updatedItem.name !== selectedAssets[0].name

          if (assetNameWasUpdated) {
            $rootScope.$emit(`asset-card-${updatedItem.id}.update-asset-name`, updatedItem.name)
          }
        }
      })

      manageAssetsDialog.open()
    })
  }

  $scope.organizeAssets = (selectedAssets) => {
    const nameDisplayLength = 32
    const assets = selectedAssets.map((selectedAsset) => {
      return {
        id: selectedAsset.id,
        assetName: Utils.truncateText(selectedAsset.name, nameDisplayLength),
        folderId: selectedAsset.folderId,
        isFolder: false,
        isOrganized: selectedAsset.isOrganized,
        currentPage: $scope.currentPage
      }
    })

    api.getOrganizeAssetDialogController().then(({ OrganizeAssetController }) => {
      const organizeAssetDialog = UdsModalService.createModal({
        controller: OrganizeAssetController,
        modalName: 'organizeAssetDialog',
        data: {
          assets,
          isRestoring: false,
          hasOrganizedFeature: $scope.pricing.organized.access
        },
        onClose: ({ hasMoved, targetFolderId }) => {
          if (hasMoved) {
            selectedAssets.forEach((asset) => {
              asset.folderId = targetFolderId || null
              asset.isOrganized = true
            })

            if ($state.current.name.includes('organized')) {
              api._removeAssetsFromList(selectedAssets, $scope.sections)
            }
          }
        }
      })

      organizeAssetDialog.open()
    })
  }

  $scope.organizeFolders = (selectedFolders) => {
    const nameDisplayLength = 32
    const folders = selectedFolders.map((selectedFolder) => {
      return {
        id: selectedFolder.id,
        assetName: Utils.truncateText(selectedFolder.title, nameDisplayLength),
        parentId: selectedFolder.parentId,
        isFolder: true
      }
    })

    api.getOrganizeAssetDialogController().then(({ OrganizeAssetController }) => {
      const organizeAssetDialog = UdsModalService.createModal({
        controller: OrganizeAssetController,
        modalName: 'organizeAssetDialog',
        data: {
          assets: folders,
          isRestoring: false,
          hasOrganizedFeature: $scope.pricing.organized.access
        },
        onClose: ({ hasMoved }) => {
          if (hasMoved) {
            api._removeAssetsFromList(selectedFolders, $scope.sections)
          }
        }
      })

      organizeAssetDialog.open()
    })
  }

  $scope.permanentlyDeleteSelectedAssets = () => {
    console.log('permanentlyDeleteSelectedAssets')
  }
}

export { FloatingToolBarController }
